module.exports = __webpack_public_path__ + "img/555.a283a872.png";